import React from 'react'
import Footer from '../Utils/Footer';
import Header from '../Utils/Header';
import EventMain from '../Utils/EventMain';

export default function Events() {
    return (
        <div>
            <Header heading="Events" />
            <EventMain />
            <Footer />
            

        </div>
    )
}
